var o2x = require("object-to-xml");

function safeXmlName(name) {
  const value = String(name ?? "").trim();
  const safe = value
    .replace(/[^A-Za-z0-9_.-]/g, "_")
    .replace(/^[^A-Za-z_]+/, "_$&");

  return safe || "_";
}

function hasMatterContext(data) {
  return !!(data && typeof data === "object" && !Array.isArray(data) && (data.Matter || data.matter || data.Case || data.case));
}

function omitMatterSurveyMeta(value, matterContext = hasMatterContext(value), inSurveys = false) {
  if (Array.isArray(value)) return value.map((item) => omitMatterSurveyMeta(item, matterContext, inSurveys));
  if (!value || typeof value !== "object") return value;
  if (value instanceof Date) return value;

  return Object.keys(value).reduce((result, key) => {
    if (matterContext && inSurveys && key === "meta") return result;

    result[key] = omitMatterSurveyMeta(
      value[key],
      matterContext,
      matterContext && String(key).toLowerCase() === "surveys"
    );
    return result;
  }, {});
}

function isBlankXmlValue(value) {
  return value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "");
}

function isDateLikeXmlKey(key) {
  const value = String(key || "");
  if (!value) return false;

  return /^(date|datetime)$/i.test(value) ||
    /^(date|datetime)([A-Z_.-]|$)/.test(value) ||
    /(Date|Datetime|DateTime)$/.test(value) ||
    /(^|[_.-])(date|datetime)([_.-]|$)/i.test(value) ||
    /(At|Time)$/.test(value);
}

function sanitizeXmlKeys(value) {
  if (Array.isArray(value)) return value.map((item) => sanitizeXmlKeys(item));
  if (!value || typeof value !== "object") return value;
  if (value instanceof Date) return value;

  return Object.keys(value).reduce((result, key) => {
    if (isDateLikeXmlKey(key) && isBlankXmlValue(value[key])) return result;

    const baseName = safeXmlName(key);
    let name = baseName;
    let index = 2;

    while (Object.prototype.hasOwnProperty.call(result, name)) {
      name = `${baseName}_${index++}`;
    }

    result[name] = sanitizeXmlKeys(value[key]);
    return result;
  }, {});
}

export function JavaScripttoXML(data) {
  var obj = {
    '?xml version="1.0" encoding="iso-8859-1"?': null,
    data: sanitizeXmlKeys(omitMatterSurveyMeta(data)),
  };

  return o2x(obj);
}
